import { Card, Form } from "react-bootstrap";

function ExtendingALSStudent({ updateStudentNo }) {
  return (
    <Card id="payment_options" className="mb-3">
      <Card.Header>
        <h4>Extending ALS Student</h4>
      </Card.Header>
      <Card.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>
              <b>Student No:</b>
            </Form.Label>
            <Form.Control
              name="student_no"
              type="number"
              min={0}
              step={1}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              onChange={(e) => updateStudentNo(e.target.value)}
            />
            <Form.Text id="passwordHelpBlock" muted>
              Please enter your "Student No" if you are a current or have
              finished a vocational course with ALS in the last 6 weeks.
            </Form.Text>
          </Form.Group>
        </Form>
      </Card.Body>
    </Card>
  );
}

export default ExtendingALSStudent;
